import { render, staticRenderFns } from "./snakeBite.vue?vue&type=template&id=4cc809a2"
import script from "./snakeBite.vue?vue&type=script&lang=js"
export * from "./snakeBite.vue?vue&type=script&lang=js"
import style0 from "./snakeBite.vue?vue&type=style&index=0&id=4cc809a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports